export const MEMBER_DETAILS = 'MEMBER_DETAILS';
export const NO_MEMBER_FOUND = 'NO_MEMBER_FOUND';
export const DISABLE_NEXT = 'DISABLE_NEXT';
export const SET_INTEGRATION_TYPE = 'SET_INTEGRATION_TYPE';
export const SET_RX_TOGGLE = 'SET_RX_TOGGLE';
export const SET_SOURCE_SYSTEM = 'SET_SOURCE_SYSTEM';
export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
export const SET_ESTIMATE_RESPONSE = 'SET_ESTIMATE_RESPONSE';
export const SET_SINGLE_ESTIMATE_RESPONSE = 'SET_SINGLE_ESTIMATE_RESPONSE';
export const SET_ALL_PROVIDERS_POOL = 'SET_ALL_PROVIDERS_POOL';
export const UPDATE_SHOW_ERROR_PAGE_VALUE = 'UPDATE_SHOW_ERROR_PAGE_VALUE';
export const UPDATE_FORM_VALUE_CUSTOM = 'UPDATE_FORM_VALUE_CUSTOM';
export const INCREMENT_SEARCH_COUNT = 'INCREMENT_SEARCH_COUNT';
export const SET_CPTT_CORRELATION_ID = 'SET_CPTT_CORRELATION_ID';
export const SET_PREVIOUS_ACTIVE_STEP = 'SET_PREVIOUS_ACTIVE_STEP';
export const SET_PLAN_BENEFITS = 'SET_PLAN_BENEFITS';
export const SET_PREVENTIVE_ESTIMATE = 'SET_PREVENTIVE_ESTIMATE';
export const SET_DIAGNOSTIC_ESTIMATE = 'SET_DIAGNOSTIC_ESTIMATE';
export const TOGGLE_IS_PREVENTIVE = 'TOGGLE_IS_PREVENTIVE';
export const CLEAR_P_AND_D_ESTIMATES = 'CLEAR_P_AND_D_ESTIMATES';
export const SET_ESTIMATE_PARAMETERS = 'SET_ESTIMATE_PARAMETERS';
export const CLEAR_PREVENTIVE_FLAGS = 'CLEAR_PREVENTIVE_FLAGS';
export const CLEAR_ESTIMATE_HISTORY = 'CLEAR_ESTIMATE_HISTORY';
export const SET_RENTAL_ESTIMATES = 'SET_RENTAL_ESTIMATES';
export const SET_PURCHASE_ESTIMATES = 'SET_PURCHASE_ESTIMATES';
export const SET_ESTIMATE_RESULTS_PAGE = 'SET_ESTIMATE_RESULTS_PAGE';
export const SET_VISION_ESTIMATE_RESPONSE = 'SET_VISION_ESTIMATE_RESPONSE';
